import React from 'react';
import { ha, rv, si, sv, gc } from 'src/assets/images'

const PartnerInvestors: React.FC = () => {
  const partners = [
    { name: 'Hyderabad Angels', logo: ha },
    { name: 'Riceberg', logo: rv },
    { name: 'Silverneedle', logo: si },
    { name: 'SucSeed', logo: sv },
    { name: 'GrowthCap.vc', logo: gc }
  ];

  return (
    <section className="partner-investors-section">
      <h2>Partner Investors</h2>
      <div className="partners-grid">
        {partners.map((partner, index) => (
          <div key={index} className="partner-logo">
            <img src={partner.logo} alt={partner.name} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartnerInvestors;
